import { BookOpen, Calendar, ClipboardList, GraduationCap, Sparkles, Users } from 'lucide-react';
import type { Materia } from '../../types/models';

type ProfVinculo = {
  professor: { id: string; nome: string; fotoUrl?: string | null };
};

function fmtAudit(iso?: string) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
  } catch {
    return '—';
  }
}

export function MateriaEditSidePanel({ materia }: { materia?: Materia | null }) {
  const profs = ((materia as Materia & { professorMaterias?: ProfVinculo[] })?.professorMaterias ?? [])
    .map((pm) => pm.professor)
    .filter(Boolean);

  const horarios = materia?._count?.horarios ?? 0;
  const chamadas = materia?._count?.chamadas ?? 0;
  const emUso = horarios + chamadas > 0;

  return (
    <div className="ac-modal-dual__side ac-materia-edit-side">
      <div className="ac-modal-dual__side-panel">
        <div className="ac-modal-dual__side-head">
          <BookOpen size={14} strokeWidth={1.5} />
          <strong>Uso na escola</strong>
        </div>
        <div className="ac-modal-dual__side-body">
          <div className="ac-materia-side-kpis">
            <div className="ac-materia-side-kpi">
              <Users size={13} />
              <div>
                <span className="ac-materia-side-kpi-val">{profs.length}</span>
                <span className="ac-materia-side-kpi-lbl">Professor(es)</span>
              </div>
            </div>
            <div className="ac-materia-side-kpi">
              <Calendar size={13} />
              <div>
                <span className="ac-materia-side-kpi-val">{horarios}</span>
                <span className="ac-materia-side-kpi-lbl">Slots na grade</span>
              </div>
            </div>
            <div className="ac-materia-side-kpi">
              <ClipboardList size={13} />
              <div>
                <span className="ac-materia-side-kpi-val">{chamadas}</span>
                <span className="ac-materia-side-kpi-lbl">Chamadas</span>
              </div>
            </div>
          </div>

          {materia?.origemBNCC && (
            <p className="ac-materia-side-hint">
              <Sparkles size={12} />
              Cadastrada via assistente BNCC
            </p>
          )}

          {emUso && (
            <p className="ac-materia-side-hint ac-materia-side-hint--info">
              Em uso na grade ou chamadas — nome e cor aparecem para toda a escola.
            </p>
          )}

          {profs.length > 0 ? (
            <div className="ac-materia-side-profs">
              <span className="ac-materia-side-profs-title">Quem leciona</span>
              <ul>
                {profs.slice(0, 6).map((p) => (
                  <li key={p.id}>
                    <span className="ac-materia-side-prof-dot" aria-hidden />
                    {p.nome}
                  </li>
                ))}
                {profs.length > 6 && (
                  <li className="ac-materia-side-profs-more">+{profs.length - 6} outros</li>
                )}
              </ul>
            </div>
          ) : (
            <p className="ac-materia-side-empty">
              <GraduationCap size={14} />
              Nenhum professor vinculado
            </p>
          )}

          <dl className="ac-materia-side-audit">
            <div>
              <dt>Inclusão</dt>
              <dd>{fmtAudit(materia?.criadoEm)}</dd>
            </div>
            <div>
              <dt>Alteração</dt>
              <dd>{fmtAudit(materia?.atualizadoEm)}</dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
}
